export default (props) => ({
  noHtml5Validate: true,
  ...props,
});
